const storageKey = "site.cookie-consent.v1";
const lifetime = 180 * 24 * 60 * 60 * 1000;
function readConsent() {
  try {
    const value = JSON.parse(localStorage.getItem(storageKey));
    return value?.version === 1 && typeof value.externalMedia === "boolean" &&
      Number.isFinite(value.savedAt) && value.savedAt <= Date.now() &&
      Date.now() - value.savedAt < lifetime ? value : null;
  } catch { return null; }
}
let consent = readConsent();
const banner = document.querySelector("[data-cookie-banner]");
const dialog = document.querySelector("[data-cookie-dialog]");
const media = dialog?.querySelector("[data-cookie-media]");

export function refreshConsentMaps() {
  document.querySelectorAll("iframe[data-consent-src]").forEach(frame => {
    const enabled = consent?.externalMedia === true && Boolean(frame.dataset.consentSrc);
    frame.hidden = !enabled;
    const placeholder = frame.parentElement.querySelector("[data-map-consent]");
    if (placeholder) placeholder.hidden = enabled;
    if (enabled) {
      if (frame.getAttribute("src") !== frame.dataset.consentSrc) frame.src = frame.dataset.consentSrc;
    } else frame.removeAttribute("src");
  });
}
function render() {
  if (banner) banner.hidden = Boolean(consent);
  refreshConsentMaps();
  window.dispatchEvent(new CustomEvent("site:consent-change", { detail: { necessary: true, externalMedia: consent?.externalMedia === true } }));
}
function save(externalMedia) {
  consent = { version: 1, savedAt: Date.now(), externalMedia };
  // Storage can be disabled. The choice still applies for the current page.
  try { localStorage.setItem(storageKey, JSON.stringify(consent)); } catch { /* In-memory choice only. */ }
  dialog?.close();
  render();
  document.querySelector(".cookie-settings-link button")?.focus({ preventScroll: true });
}
document.querySelectorAll("[data-cookie-settings]").forEach(button => {
  button.hidden = !dialog;
  button.addEventListener("click", () => {
    media.checked = consent?.externalMedia === true;
    if (!dialog.open) dialog.showModal();
  });
});
document.querySelectorAll("[data-cookie-accept]").forEach(button => button.addEventListener("click", () => save(true)));
document.querySelectorAll("[data-cookie-reject]").forEach(button => button.addEventListener("click", () => save(false)));
dialog?.querySelector("[data-cookie-save]").addEventListener("click", () => save(media.checked));
dialog?.querySelector("[data-cookie-close]").addEventListener("click", () => dialog.close());
window.addEventListener("storage", event => {
  if (event.key === storageKey || event.key === null) {
    consent = readConsent();
    if (media) media.checked = consent?.externalMedia === true;
    render();
  }
});
render();
